import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const CanaraBank = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
  ?.filter((card) => card.title?.toLowerCase().includes("canara"))
  .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Does Canara Bank offer both Rupay and Visa cards?",
      answer:
        " Yes, Canara Bank issues cards on both Rupay and Visa networks, enabling domestic and international transactions.",
    },
    {
      question: "Is there an annual fee on Canara Bank credit cards?",
      answer:
        " Many Canara Bank credit cards come with zero or minimal annual fees, and some offer fee waivers on meeting spending milestones.",
    },
    {
      question: "Can I apply for a credit card if I don’t have a Canara Bank account?",
      answer:
        "  Yes, even non-account holders can apply, though existing customers may enjoy faster processing.",
    },
    {
      question: "How long does it take to get a Canara Bank credit card?",
      answer:
        "  Once your application is submitted with all documents, approval typically takes 5–7 working days, with card delivery in 7–10 days.",
    },
    {
      question: "Do Canara Bank cards offer EMI conversion?",
      answer:
        "  Yes, many Canara Bank credit cards allow EMI conversion for high-ticket purchases at attractive interest rates.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Eligibility Guidelines",
      description:
        "   Review the card-specific criteria, including minimum age, income bracket, and required credit score. Being informed reduces rejection risks.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Organize Required Documents",
      description:
        "  Have all KYC documents—PAN, address, income proof, and ID—ready for smooth processing.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Redirect to Canara Bank’s Official Site",
      description:
        "  Click “Apply Now” on your chosen card, and you’ll be redirected to Canara Bank’s official credit card application portal to complete your application.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "  Visit TheFinMaster to explore a carefully selected list of Union Bank credit cards. Each listing features comprehensive overviews, rewards structure, annual fees, and best-use recommendations to help you choose smartly.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Get Bank of Baroda (BOB) Credit Card 2024 - Compare &amp; Apply Online
          at TheFinmaster
        </title>
        <meta
          name="description"
          content="Bank of Baroda Credit Cards - Check all types of Bank of Baroda bank credit cards list &amp; their benefits to select the right card for you. Apply for top &amp; best Bank of Baroda credit card now. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="abank of baroda lifetime free credit card, bob easy credit card apply, bank of baroda hpcl credit card, bank of baroda snapdeal credit card, bobcard payment"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/union-bank/credit-card-bank"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 mt-10">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Reliable, Rewarding & Secure: Canara Bank’s Credit Cards for Every Lifestyle{" "}
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
            Canara Bank, one of India’s oldest public sector banks, offers a suite of credit cards that are secure, user-friendly, and packed with everyday benefits. Whether you're looking for a card for online shopping, fuel savings, or building your credit profile, Canara Bank credit cards are thoughtfully designed with low annual fees, Rupay/Visa options, EMV security, and practical reward systems. With a balance of conservative features and dependable performance, these cards are ideal for salaried professionals, pensioners, and conservative spenders seeking value with peace of mind.
            </p>
          </div>
        </div>
        <h1 className="text-center text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

         <div className="w-full relative ">
                   <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                     {/* <div className="w-[70%] mx-auto">
                                                                  <h2 className="text-center font-medium pt-5 text-lg">
                                                                    <span className="font-semibold text-white">816 people</span>{" "}
                                                                    are on call with our advisors right now
                                                                  </h2>
                                                                </div> */}
                     <div className="w-full mx-auto">
                       <Link
                         to="https://play.google.com/store/apps/details?id=com.fatakpay&pcampaignid=web_share"
                         target="_blank"
                         rel="noopener noreferrer"
                       >
                         <div className="w-[80%] mx-auto ">
                           <img src="/assets/ftak.jpg" alt="Advertisement" />
                         </div>
                       </Link>
                       <div className="bg-white">
                         {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                                      Know your advisor
                                                                    </h3> */}
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        

        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                Eligibility Criteria to Apply for Canara Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Age Criteria
                  </span>
                  <span>
                    {" "}
                    Applicants must be 21 years or above for a primary card. Add-on cards can be issued to family members above 18 years.
                    {" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Income Requirements
                  </span>
                  <span>
                    {" "}
                    Salaried individuals should have a minimum monthly income of ₹15,000–₹20,000, while self-employed applicants must show consistent earnings via ITRs.                  </span>{" "}
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  CIBIL Score Requirement
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 700 or above is recommended to enhance approval chances, especially for premium variants.                 </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Employment Type
                  </span>
                  <span>
                    {" "}
                    Open to salaried, self-employed professionals, and retired government employees/pensioners with a stable income stream.
                    </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Existing Banking Relationship
                  </span>
                  <span>
                    {" "}
                    Existing Canara Bank account holders may benefit from faster approvals and simplified KYC processes.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for Canara Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Identity Proof
                  </span>
                  <span>
                    {" "}
                    Acceptable documents include Aadhaar Card, Voter ID, Passport, or PAN Card with a clear photograph.                    </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Address Proof
                  </span>
                  <span>
                    {" "}
                    Any one of utility bills, passport, Aadhaar, or rental agreement showing your current residential address.

                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Latest 3 months’ salary slips or Form 16. Self-employed: Recent ITR, business proof, and bank account statement (6 months).

 

                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Photograph
                  </span>
                  <span>
                    {" "}
                    One recent passport-size color photo is required if submitting documents physically.
                    </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card Copy
                  </span>
                  <span>
                    {" "}
                    Mandatory for credit applications and compliance. Make sure it's updated and linked to Aadhaar.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
        How to Apply for Canara Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CanaraBank;
